<script>
    import R, {LOADER} from "../lib/requests";
    import Modal from '../components/modal/Modal.svelte';

    export let transporterId = 0;
    export let transporters = null;
    export let closeCallback;

    const load = () => {
        const onSuccess = result => {
            transporters = result;
        }

        const onFailure = err => {
        };

        const data = {
            is_active: 1,
        }

        R.handle(R.transporter.index, data, onSuccess, onFailure, LOADER.POPUP);
    }


    const onSelect = (transporter) => {
        close(transporter);
    }


    const close = (param) => {
        if (param instanceof Event) {
            closeCallback();
            return;
        }

        closeCallback(param);
        // setTimeout(() => {
        //     closeCallback(param);
        // }, 200);
    }

    if (transporters == null || !transporters.length) {
        load();
    }
</script>
<Modal title="Select Transporter" on:close="{ close }">
    <div slot="body">
        <table class="table table-list">
            <tbody>
            {#if transporters}
                {#each transporters as transporter}
                    <tr class="row-hover pointer"
                        class:row-selected={transporterId == transporter.id }
                        on:click={ () => onSelect(transporter) }>
                        <td>{ transporter.name }</td>
                    </tr>
                {/each}
            {/if}
            </tbody>
        </table>
        <hr class="mt-0">
        <div class="text-end">
            <button class="btn btn-link" on:click={ close }>Cancel</button>
        </div>
    </div>
</Modal>
